<template>
    <div class="flex flex-column mb-3 gap-3">
        <div class="grid">
            <!-- <div class="col-12 md:col-4 sm:col-4">
                <div class="flex h-full border-round-lg surface-50 border border-200 flex flex-column align-items-start p-2 xl:p-3 lg:p-3">
                    <div class="text-500 text-sm mb-1">Курс RUB/USDT</div>
                    <div class="font-bold text-xl">{{ stateRate }}</div>
                </div>
            </div> -->
            <div class="col-12 md:col-4 sm:col-4">
                <div class="flex h-full p-3 border-round-lg surface-50 border border-200 flex flex-column align-items-start">
                    <div class="text-500 text-sm mb-1">Всего заказов</div>
                    <div class="font-bold text-xl">{{ stateTotalOrders }}</div>
                    <div class="text-500 text-sm">На сумму: <span class="font-medium">{{ stateTotalAmount }} RUB</span></div>
                    <div class="text-500 text-sm">На сумму: <span class="font-medium">{{ getRatedAmount(stateTotalAmount, stateRate) }} USDT</span></div>
                </div>
            </div>
            <div class="col-12 md:col-4 sm:col-4">
                <div class="flex h-full p-3 border-round-lg surface-50 border border-200 flex flex-column align-items-start">
                    <div class="text-500 text-sm mb-1">Количество по статусам:</div>
                    <div class="font-medium text-sm text-blue-600">{{ getStatusTitle('pending') }}: {{ (stateCountByStatus.pending!=undefined) ? stateCountByStatus.pending : 0 }}</div>
                    <div class="font-medium text-sm text-primary">{{ getStatusTitle('processing') }}: {{ (stateCountByStatus.processing!=undefined) ? stateCountByStatus.processing : 0 }}</div>
                    <div class="font-medium text-sm text-green-500">{{ getStatusTitle('paid') }}: {{ (stateCountByStatus.paid!=undefined) ? stateCountByStatus.paid : 0 }}</div>
                    <div class="font-medium text-sm text-green-500">{{ getStatusTitle('confirmed') }}: {{ (stateCountByStatus.confirmed!=undefined) ? stateCountByStatus.confirmed : 0 }}</div>
                    <div class="font-medium text-sm text-red-500">{{ getStatusTitle('canceled') }}: {{ (stateCountByStatus.canceled!=undefined) ? stateCountByStatus.canceled : 0 }} </div>
                    <div class="font-medium text-sm text-orange-700">{{ getStatusTitle('failed') }}: {{ (stateCountByStatus.failed!=undefined) ? stateCountByStatus.failed : 0 }} </div>
                </div>
            </div>
            <div class="col-12 md:col-4 sm:col-4">
                <div class="flex h-full p-3 border-round-lg surface-50 border border-200 flex flex-column align-items-start">
                    <div class="text-500 text-sm mb-1">Сумма по статусам:</div>
                    <div class="font-medium text-sm text-blue-600">{{ getStatusTitle('pending') }}: {{ (stateAmountByStatus.pending!=undefined) ? stateAmountByStatus.pending : 0 }} RUB</div>
                    <div class="font-medium text-sm text-primary">{{ getStatusTitle('processing') }}: {{ (stateAmountByStatus.processing!=undefined) ? stateAmountByStatus.processing : 0 }} RUB</div>
                    <div class="font-medium text-sm text-green-500">{{ getStatusTitle('paid') }}: {{ (stateAmountByStatus.paid!=undefined) ? stateAmountByStatus.paid : 0 }} RUB</div>
                    <div class="font-medium text-sm text-green-500">{{ getStatusTitle('confirmed') }}: {{ (stateAmountByStatus.confirmed!=undefined) ? stateAmountByStatus.confirmed : 0 }} RUB</div>
                    <div class="font-medium text-sm text-red-500">{{ getStatusTitle('canceled') }}: {{ (stateAmountByStatus.canceled!=undefined) ? stateAmountByStatus.canceled : 0 }} RUB</div>
                    <div class="font-medium text-sm text-orange-700">{{ getStatusTitle('failed') }}: {{ (stateAmountByStatus.failed!=undefined) ? stateAmountByStatus.failed : 0 }} RUB</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import BigNumber from 'bignumber.js'

export default {
    props: {
        
    },
    data() {
        return {
            
        }
    },
    components: {

    },
    computed: {
        stateTotalOrders: function () { return this.$store.getters.StateTotalOrders },
        stateTotalAmount: function () { return this.$store.getters.StateTotalAmount },
        stateAmountByStatus: function () { return this.$store.getters.StateAmountByStatus },
        stateCountByStatus: function () { return this.$store.getters.StateCountByStatus },
        stateRate: function () { return this.$store.getters.StateRate },
    },
    methods: {
        getStatusTitle(status) {
            return this.helper.getStatusTitle(status)
        },
        getRatedAmount(amount, rate) {
            if(!amount || !rate) return 0
            const bAmount = new BigNumber(amount)
            const bRate = new BigNumber(rate)
            const result = bAmount.dividedBy(bRate)
            return result.toFixed(2)
        },
    },
    async mounted() {
        
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>